import {
  FILTER_MODAL_OPENED,
  FILTER_MODAL_CLOSED,
  RESET_FILTER_MODAL,
} from 'actions/meetings/filter_modal'

const initialState = {
  isOpen: false,
  reset_filter: false
}

export const meetingsFilterModal = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_MODAL_OPENED:
      return {
        ...state,
        isOpen: true
      }

    case FILTER_MODAL_CLOSED:
      return {
        ...state,
        isOpen: false
      }

    case RESET_FILTER_MODAL:
      return {
        ...state,
        reset_filter: true
      }

    default:
      return state
  }
}
